import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimaryTreatment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="m9.81 9.557-.407 1.417s.113.414 1.016.414 1.016-.414 1.016-.414l-.405-1.417M1.403 7.556c.195-.116 5.523-3.019 9.017-3.019s8.822 2.903 9.017 3.019.289.349 0 .523c-.288.175-1.916-.756-2.03-.523-.112.232.452 1.046.452 2.21 0 1.162-.677 1.801-.451 2.034.225.232 1.804-.465 2.03-.523s.225.349 0 .523c-.226.174-4.791 3.663-9.018 3.663S1.628 11.974 1.403 11.8c-.226-.174-.226-.581 0-.523.225.058 1.804.756 2.03.523s-.452-.872-.452-2.035.564-1.977.451-2.21-1.74.699-2.03.524c-.288-.174-.195-.407 0-.523Zm6.82.407c.9 0 1.295.814 1.295.814s-.394.523-1.296.465c-.901-.058-1.296-.756-1.296-.756s.395-.523 1.296-.523Zm2.197 4.305c-1.128 0-1.694.489-1.694.489s.454.815 1.694.815 1.694-.815 1.694-.815-.567-.49-1.694-.49Zm2.198-4.305c-.902 0-1.296.814-1.296.814s.394.523 1.296.465 1.296-.756 1.296-.756-.394-.523-1.296-.523Z"
    />
  </svg>
);
export default SvgPrimaryTreatment;
